module.exports = __webpack_public_path__ + "img/myCard3.1651c3da.jpg";